import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useHomePath } from "@/hooks/use-home-path";
import { Button } from "@/components/ui";

export function NotFoundPage() {
  const home = useHomePath();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <div className="rounded-full bg-surface-sunken p-4 dark:bg-night-sunken">
        <Compass className="h-6 w-6 text-ink-subtle" />
      </div>
      <h1 className="mt-4 text-lg font-semibold text-ink dark:text-slate-100">
        Page not found
      </h1>
      <p className="mt-1 max-w-sm text-sm text-ink-muted dark:text-slate-400">
        That screen does not exist. Use the sidebar, or press{" "}
        <kbd className="kbd">⌘K</kbd> to search for a record.
      </p>
      {/* Back to YOUR home, not to the accountant's. */}
      <Link to={home} className="mt-4">
        <Button>Back to {home === "/simple" ? "the overview" : "the dashboard"}</Button>
      </Link>
    </div>
  );
}
